import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/")({
    beforeLoad: () => {
        throw redirect({ to: "/users/patients", replace: true });
    },
});
